import * as React from "react";
const SvgPlus = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 18 18", ...props }, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M8.25 9.75V15h1.5V9.75H15v-1.5H9.75V3h-1.5v5.25H3v1.5z" }));
export default SvgPlus;
